"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
exports.documentMouseMove$ = rxjs_1.fromEvent(document, 'mousemove');
exports.documentMouseUp$ = rxjs_1.fromEvent(document, 'mouseup');
exports.keyDowns$ = rxjs_1.fromEvent(document, 'keydown');
exports.keyUps$ = rxjs_1.fromEvent(document, 'keyup');
/**
 * Throttle an Observable to available animation
 * frames until a second Observable omits a value.
 *
 * @param observable$ Observable to monitor
 * @param until$ Observable that triggers an end to monitoring
 * @param onComplete Callback function that signals monitoring has ending
 */
exports.requestAnimationFramesUntil = function (observable$, until$, onComplete) {
    var animationFrame$ = rxjs_1.interval(0, rxjs_1.animationFrameScheduler);
    var throttled$ = animationFrame$.pipe(operators_1.withLatestFrom(observable$, function (_, observed) { return observed; }), operators_1.takeUntil(until$));
    throttled$.subscribe({
        complete: function () { return onComplete && onComplete(); },
    });
    return throttled$;
};
/**
 * Is the KeyboardEvent for a key down?
 */
var isKeydown = function (e) { return e.type === 'keydown'; };
/**
 * Has the pressed state of a key changed between two events?
 */
var pressedStateHasChanged = function (x, y) {
    return x.type === y.type;
};
/**
 * Observable of whether shift is currently being held down.
 */
var SHIFT_KEY_CODE = 16;
exports.shiftIsPressed$ = exports.keyDowns$.pipe(operators_1.merge(exports.keyUps$), operators_1.filter(function (e) { return e.keyCode === SHIFT_KEY_CODE; }), operators_1.distinctUntilChanged(pressedStateHasChanged), operators_1.map(isKeydown), operators_1.startWith(false));
//# sourceMappingURL=misc.js.map